/**
 * These constants are the query parameters used across multiple pages in the app.
 */
export enum QueryParameter {
  /**
   * The previous path before entering a workflow.  Primarily used to redirect
   * a user back to a page after workflow is complete.
   */
  PrevPath = 'prevPath',
  /**
   * The path to send a user to after a workflow as completed.  Unlike previous path
   * a user may not be coming from this path.
   */
  NextPath = 'next',
  /**
   * When updating a credit card, set as the default card
   */
  UseCardAsDefaultSource = 'useCardAsDefaultSource',
  /**
   * The type of referrer code used in the REST /referrer endpoint
   */
  ReferrerType = 'type',
  /**
   * The referrer code used in the REST /referrer endpoint
   */
  ReferrerCode = 'code',
  /**
   * A referral code
   */
  ReferralCode = 'ref',
  /**
   * An email subject
   */
  Subject = 'subject',
  /**
   * The type of quote being requested from the REST /quote endpoint
   */
  QuoteMode = 'mode',
  /**
   * The name of a pet
   */
  PetName = 'pet',
  /**
   * An email address
   */
  Email = 'email',
  /**
   * Boolean to indicate that a food plan is a mixing plan
   */
  IsMixing = 'isMixing',
  /**
   * A boolean to indicate enable the topper options in a signup mixing plan
   */
  Topper = 'topper',
  /**
   * A user's id
   */
  UserId = 'userId',
  /**
   * Identify the advertiser, site, publication, etc. that is sending traffic to your property
   * https://support.google.com/analytics/answer/1033863
   */
  UtmSource = 'utm_source',
  /**
   * The advertising or marketing medium
   * https://support.google.com/analytics/answer/1033863
   */
  UtmMedium = 'utm_medium',
  /**
   * The individual campaign name, slogan, promo code, etc. for a product
   * https://support.google.com/analytics/answer/1033863
   */
  UtmCampaign = 'utm_campaign',
  /**
   * Identify paid search keywords. If you're manually tagging paid keyword campaigns,
   * you should also use utm_term to specify the keyword.
   * https://support.google.com/analytics/answer/1033863
   */
  UtmTerm = 'utm_term',
  /**
   * Used to differentiate similar content, or links within the same ad.
   * For example, if you have two call-to-action links within the same email message,
   * you can use utm_content and set different values for each so you can tell which version is more effective.
   * https://support.google.com/analytics/answer/1033863
   */
  UtmContent = 'utm_content',
  /**
   * The parameter used to toggle between DIY and fresh during Signup
   */
  ProductLine = 'productLine',
  /**
   * The parameter used to indicate how many pets a user is signing up for on me page.
   */
  PetCount = 'petCount',
  /**
   * Indicates the entry point for a workflow. Not used for redirects; only analytics.
   */
  EntryPoint = 'entryPoint',
  /**
   * Boolean to indicate that the "Get Started" step should be skipped during signup
   */
  SkipGetStarted = 'skipGetStarted',
  /**
   * A parameter used to detail offers from an external channel link
   */
  Offer = 'offer',
  /**
   * A parameter used to enable the minimum calorie mixing plan offer
   */
  MinimumCalorieMixingPlan = 'minimumCalorieMixingPlan',
  /**
   * An order key for a requested order
   */
  RequestedOrderKey = 'requested_order_key',
  /**
   * The next ship date before a user reschedules their next delivery.  Used to determine if a user updated their next ship date during the reschedule flow.
   */
  NextDateBeforeReschedule = 'nextDateBeforeReschedule',
}
